interface PaymentCancellationResponse {
  code?: string
  message?: string
  error_code?: string
  error_msg?: string
}

export function isPaymentCanceled(response?: PaymentCancellationResponse): boolean {
  const cancelCodes = ['PAY_PROCESS_CANCELED', 'PAYMENT_CANCELLED', 'USER_CANCEL']
  return (
    [response?.code, response?.error_code].some((code) => cancelCodes.includes(code ?? '')) ||
    [response?.message, response?.error_msg].some((message) => message?.startsWith('[PAY_PROCESS_CANCELED]'))
  )
}
